// extracted by mini-css-extract-plugin
export default {"Chat":"Chat_Chat__W5qQe","Conversation":"Chat_Conversation__pPGxV","Content":"Chat_Content__Xw4yz","ConversationWide":"Chat_ConversationWide__LgRsK"};